import React from 'react'

import {
  SourceInputs,
  PathExamplesHelp,
  RemoveRowButton,
  ArrayLevelError,
  RowError,
} from '../pathMapping/SourceRow'

import { PREFIX_OPTION_GROUPS, PATH_EXAMPLES, isWholeValuePrefix } from './tokenSources'

/**
 * TCN's binding of the shared path-mapping row.
 *
 * The row primitives moved to ../pathMapping so a single-payload connector can use
 * them without a source dropdown. Everything TCN-specific -- the four payload
 * prefixes, their per-prefix path examples, and the two whole-value tokens -- lives
 * here, and the old names are re-exported so the campaign-name and call-metadata
 * editors are untouched.
 */

export { RemoveRowButton as TcnRemoveRowButton, ArrayLevelError, RowError }

export const TcnSourceInputs = (props) => (
  <SourceInputs
    sources={PREFIX_OPTION_GROUPS}
    examples={PATH_EXAMPLES}
    isWholeValue={isWholeValuePrefix}
    {...props}
  />
)

const TCN_EXAMPLES = [
  {
    term: (
      <>
        <code>Client Info</code> → <code>rows[fieldLabel=DBCLNT].fieldValue</code>
      </>
    ),
    definition: 'contact field, matched case-insensitively',
  },
  {
    term: (
      <>
        <code>Client Info</code> → <code>callerId</code>
      </>
    ),
    definition: 'top-level value, beside the contact fields',
  },
  {
    term: (
      <>
        <code>Call Data</code> → <code>ivrData.someField</code>
      </>
    ),
    definition: 'nested value',
  },
  {
    term: (
      <>
        <code>User Details</code> → <code>skills[name=Ubiquity].description</code>
      </>
    ),
    definition: 'pick a list element by field, then keep going',
  },
]

export const TcnSourceHelp = () => (
  <PathExamplesHelp
    intro="Pick where the value comes from, then the path to it within that payload."
    examples={TCN_EXAMPLES}
    outro="Arrays have no guaranteed order, so select from them by field rather than by position. Call Direction and Hunt Group are whole values and take no path."
  />
)
